import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { tours } from "../data/Tours";

// Učitaj ažurirane podatke
const getTours = () => {
  const saved = localStorage.getItem("travelina_tours");
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      return tours;
    }
  }
  return tours;
};

const categories = [
  { id: "all", key: "tours.filterAll" },
  { id: "beach", key: "tours.filterBeach" },
  { id: "city", key: "tours.filterCity" },
  { id: "adventure", key: "tours.filterAdventure" },
  { id: "romantic", key: "tours.filterRomantic" },
];

const TOUR_TITLES = {
  barcelona: {
    hr: "Barcelona & Costa Brava",
    en: "Barcelona & Costa Brava",
    de: "Barcelona & Costa Brava",
    es: "Barcelona y Costa Brava",
  },
  mexico: {
    hr: "Meksički kolonijalni gradovi i Karibi",
    en: "Mexican colonial cities & Caribbean",
    de: "Mexikanische Kolonialstädte & Karibik",
    es: "Ciudades coloniales y Caribe mexicano",
  },
  tuscany: {
    hr: "Toskana i Cinque Terre",
    en: "Tuscany & Cinque Terre",
    de: "Toskana & Cinque Terre",
    es: "Toscana y Cinque Terre",
  },
  valladolid: {
    hr: "Valladolid",
    en: "Valladolid",
    de: "Valladolid",
    es: "Valladolid",
  },
  alicante: {
    hr: "Alicante",
    en: "Alicante",
    de: "Alicante",
    es: "Alicante",
  },
};

const TOUR_DESCRIPTIONS = {
  barcelona: {
    hr: "Kratki obilazak Barcelone i izlet na Costa Bravu uz opušten ritam.",
    en: "Short Barcelona stay with a relaxed Costa Brava escape.",
    de: "Kurzaufenthalt in Barcelona mit entspanntem Costa-Brava-Ausflug.",
    es: "Estancia en Barcelona y escapada relajada a la Costa Brava.",
  },
  mexico: {
    hr: "Spoj povijesti, ulične hrane i nekoliko dana odmora na plaži.",
    en: "A mix of history, street food and beach relaxation.",
    de: "Eine Mischung aus Geschichte, Streetfood und Strandentspannung.",
    es: "Mezcla de historia, comida callejera y relax en la playa.",
  },
  tuscany: {
    hr: "Vinarije, sela na brežuljcima i šareni gradići uz more.",
    en: "Wineries, hilltop villages and colorful seaside towns.",
    de: "Weingüter, Hügellandschaften und bunte Küstenorte.",
    es: "Bodegas, pueblos en colinas y pueblos costeros de colores.",
  },
  valladolid: {
    hr: "Otkrijte španjolski grad bogat poviješću i kulturom.",
    en: "Discover a Spanish city rich in history and culture.",
    de: "Entdecken Sie eine spanische Stadt voller Geschichte und Kultur.",
    es: "Descubre una ciudad española rica en historia y cultura.",
  },
  alicante: {
    hr: "Uživajte u sunčanoj obali i bogatoj kulturi.",
    en: "Enjoy the sunny coast and rich culture.",
    de: "Genießen Sie die sonnige Küste und reiche Kultur.",
    es: "Disfruta de la costa soleada y la rica cultura.",
  },
};

function formatDate(dateStr, lng) {
  const date = new Date(dateStr);
  return date.toLocaleDateString(lng || "hr-HR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export default function Tours() {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState("all");
  const currentTours = getTours();

  const filtered =
    active === "all" ? currentTours : currentTours.filter((tour) => tour.category === active);

  return (
    <section id="tours" className="section">
      <div className="container">
        <header className="section-header">
          <h2>{t("tours.sectionTitle")}</h2>
          <p>{t("tours.sectionSubtitle")}</p>
        </header>

        <div className="filters">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`filter-btn ${active === cat.id ? "active" : ""}`}
              onClick={() => setActive(cat.id)}
            >
              {t(cat.key)}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="no-tours">{t("tours.noTours")}</p>
        ) : (
          <div className="tours-grid">
            {filtered.map((tour) => {
              const lng = i18n.language || "hr";
              const base = lng.slice(0, 2);
              const title =
                TOUR_TITLES[tour.key][base] || TOUR_TITLES[tour.key].en;
              const desc =
                TOUR_DESCRIPTIONS[tour.key][base] ||
                TOUR_DESCRIPTIONS[tour.key].en;
              return (
                <article className="tour-card" key={tour.id}>
                  <div
                    className="tour-image"
                    style={{ backgroundImage: `url(${tour.image})` }}
                  >
                    <div className="tour-tag">{tour.tag}</div>
                  </div>
                  <div className="tour-body">
                    <h3>{title}</h3>
                    <div className="tour-meta">
                      <span>📍 {tour.country}</span>
                      <span>🗓 {formatDate(tour.date, lng)}</span>
                      <span>
                        ⏳ {tour.days} d / {tour.nights} {t("tours.nights")}
                      </span>
                    </div>
                    <p className="tour-description">{desc}</p>
                    <div className="tour-footer">
                      <div className="tour-price">
                        <span className="tour-price-main">
                          {t("tours.from")} {tour.price} €
                        </span>
                        <span className="tour-price-note">
                          {t("tours.perPerson")}
                        </span>
                      </div>
                      <button className="btn ghost">
                        {t("tours.btnDetails")}
                      </button>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
